import {SystemMemoryProps} from "../../../models/SystemMemoryProps";
import {Space} from "@mantine/core";
import {TableEditor} from "../../TableEditor";
import {IconCalendar, IconFileDescription, IconHash, IconId, IconSignature, IconFavicon} from "@tabler/icons-react";
import {ApiDataHelper} from "../../../data/ApiDataHelper";
import {AdminPortfolioTagModel} from "../../../models/admin/portfolio/AdminPortfolioTagModel";

export function AdminPortfolioTags(memory: SystemMemoryProps) {
    return (
        <>
            <Space h="lg"/>
            {TableEditor<AdminPortfolioTagModel>({
                headers: [
                    {title: 'ID', key: 'id', type: 'text', viewOnly: true, icon: <IconId size="0.8rem"/>},
                    {title: 'Name', key: 'name', type: 'text', viewOnly: false, icon: <IconSignature size="0.8rem"/>},
                    {title: 'Description', key: 'description', type: 'rich', viewOnly: false, icon: <IconFileDescription size="0.8rem"/>},
                    {title: 'Colour Code', key: 'colourCode', type: 'colour', viewOnly: false, icon: <IconHash size="0.8rem"/>},
                    {title: 'Documentation URL', key: 'documentation', type: 'rich', viewOnly: false, icon: <IconFavicon size="0.8rem"/>},
                    {title: 'Created', key: 'created', type: 'text', viewOnly: true, icon: <IconCalendar size="0.8rem"/>}
                ],
                apiObject: new ApiDataHelper(memory),
                getURL: '/v1/admin/portfolio/tags',
                postURL: {url: '/v1/admin/portfolio/tag/insert', keys: ['name', 'description', 'colourCode', 'documentation']},
                putURL: {url: '/v1/admin/portfolio/tag/update', keys: ['name', 'description', 'colourCode', 'documentation']},
                delURL: '/v1/admin/portfolio/tag/delete'
            })}
        </>
    );
}